$(function () {
  $('.vogue-swiper').each((index, item) => {
    let id = $(item).parent()[0].id;
    let count = $('#' + id + ' .vogue-swiper').attr('data-count');
    let interval = $('#' + id + ' .vogue-swiper').attr('data-interval');
    let auto = $('#' + id + ' .vogue-swiper').attr('data-autoplay') == '0' ? false : true;
    var autoplay = auto;
    if (auto) {
      if (count <= 1) {
        autoplay = false
      }
      if (interval == '0') {
        autoplay = false
      }
    }

    var swiper = new window.AwesomeSwiper.Swiper('#' + id + ' .swiper-container', {
      loop: true,
      autoHeight: true, //高度
      autoplay: autoplay ? {
        delay: interval * 1000
      } : false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: '.vogue-button-next',
        prevEl: '.vogue-button-prev',
      },

    });
    $('#' + id + ' .swiper-slide img').on("load", function () {
      swiper.update();
    })


    if (count <= 1) {
      $('.vogue-swiper .vogue-button-prev').attr('style', 'display: none !important');
      $('.vogue-swiper .vogue-button-next').attr('style', 'display: none !important');
      $('#' + id + ' .swiper-pagination-bullets').css('display', 'none');
    }

  })

})

let video_all = $('.vogue-video');
video_all.each(item => {
  let autoplay = $(video_all[item]).attr('video-auto');
  let video_src = $(video_all[item]).attr('video-src');

  let obtn = $(video_all[item]).find('.video');
  let oatn = $(video_all[item]).find('.video-area');

  if (obtn.length) {
    if (autoplay) {
      obtn.css("display", "none");
      oatn.css("display", "block");
    } else {
      obtn.css("display", "block");
      oatn.css("display", "none");
    }
  } else {
    obtn.css("display", "none");
    oatn.css("display", "block");
    $(video_all[item]).find('iframe').src = video_src;
  }
  obtn.click(function () {
    obtn.css("display", "none");
    $(video_all[item]).find('iframe').src = video_src;
    oatn.css("display", "block");
  });

})
